export const quotes = [
  {
    text: "Bitcoin is hope.",
    author: "Saylor"
  },
  {
    text: "You don't sell your Bitcoin. You wait for it to come to you.",
    author: "Saylor"
  },
  {
    text: "Bitcoin is a swarm of cyber hornets serving the goddess of wisdom, feeding on the fire of truth, exponentially growing ever smarter, faster, and stronger behind a wall of encrypted energy.",
    author: "Saylor"
  },
  {
    text: "I'm sure that in 20 years there will either be very large transaction volume or no volume.",
    author: "Satoshi"
  },
  {
    text: "The Federal Reserve is the biggest Ponzi scheme in the world.",
    author: "Saylor"
  }
]

export default quotes
